import { User } from "./User";

export class CopilotUser implements User
{
    public userId : string;

    public constructor(userId : string)
    {
        this.userId = userId;
    }

    public clone() : User
    {
        return (new CopilotUser(this.userId));
    }
}